import styles from './Loader.module.css'

const Loader = () => {

    return (
        <div className={styles.loader__wrapper}>
            <p>Завантаження...</p>
        </div>
    );
}

export default Loader;